import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "n-emoji-picker" }
const _hoisted_2 = {
  key: 2,
  class: "arrow-down"
}

import { ref } from 'vue';
import { Picker, EmojiIndex } from 'emoji-mart-vue-fast/src';
import emojiList from '../../../data/emoji-list';
import NButton from '../../control/button/button.vue';


export default /*@__PURE__*/_defineComponent({
  ...{
  name: 'n-emoji-picker',
},
  __name: 'emoji-picker',
  props: {
  accentColour: {
    type: String,
    default: '#062b80',
  },
},
  emits: ["emojiSelect"],
  setup(__props, { emit: __emit }) {





const emit = __emit;

const emojiPickerOpen = ref(false);

const ei = new EmojiIndex(emojiList, {
  recentLength: 8,
  exclude: ['flags', 'symbols'],
});

function toggleOpen() {
  emojiPickerOpen.value = !emojiPickerOpen.value;
}

function insertEmoji(emoji: any) {
  toggleOpen();
  emit('emojiSelect', emoji);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["n-emoji-picker__button-container", { 'n-emoji-picker__button-container--open': emojiPickerOpen.value }]),
      style: _normalizeStyle({ color: __props.accentColour })
    }, [
      _createVNode(NButton, {
        icon: "emoji",
        variant: "action",
        class: "n-message-composer__emoji-button",
        onClick: toggleOpen
      })
    ], 6),
    (emojiPickerOpen.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "n-emoji-picker__overlay",
          onClick: toggleOpen
        }))
      : _createCommentVNode("", true),
    (emojiPickerOpen.value)
      ? (_openBlock(), _createBlock(_unref(Picker), {
          key: 1,
          "emoji-size": 21,
          perLine: 10,
          native: true,
          showPreview: false,
          data: _unref(ei),
          onSelect: insertEmoji,
          class: "emoji-picker"
        }, null, 8, ["data"]))
      : _createCommentVNode("", true),
    (emojiPickerOpen.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _cache[0] || (_cache[0] = [
          _createElementVNode("div", { class: "inner-arrow" }, null, -1)
        ])))
      : _createCommentVNode("", true)
  ]))
}
}

})